<template>
  <v-container fluid>
    <v-layout
      v-if="Array.isArray(data.names) && data.names.length"
      justify-center
    >
      <v-flex md12>
        <jti-expansion-panel panelName="Same Name">
          <v-data-table
            :headers="headers"
            :items="data.names"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', 'text-xs-' + header.align]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left text-uppercase">
                {{ props.item.first_name }}
              </td>

              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.middle_name }}
              </td>
              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.last_name }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.email }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.contact_no }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.birth_date }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.date_registered }}
              </td>
            </template>
          </v-data-table>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="Array.isArray(data.emails) && data.emails.length"
      justify-center
    >
      <v-flex md12>
        <jti-expansion-panel panelName="Same Email Address">
          <v-data-table
            :headers="headers"
            :items="data.emails"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', 'text-xs-' + header.align]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left text-uppercase">
                {{ props.item.first_name }}
              </td>

              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.middle_name }}
              </td>
              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.last_name }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.email }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.contact_no }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.birth_date }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.date_registered }}
              </td>
            </template>
          </v-data-table>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="Array.isArray(data.contacts) && data.contacts.length"
      justify-center
    >
      <v-flex md12>
        <jti-expansion-panel panelName="Same Contact Number">
          <v-data-table
            :headers="headers"
            :items="data.contacts"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable', 'text-xs-' + header.align]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + 1 }}
              </td>

              <td class="text-xs-left text-uppercase">
                {{ props.item.first_name }}
              </td>

              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.middle_name }}
              </td>
              <td class="text-no-wrap text-xs-left text-uppercase">
                {{ props.item.last_name }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.email }}
              </td>
              <td class="text-no-wrap text-xs-left">
                {{ props.item.contact_no }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.birth_date }}
              </td>
              <td class="text-no-wrap text-xs-center">
                {{ props.item.date_registered }}
              </td>
            </template>
          </v-data-table>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "First Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Middle Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Last Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Email Address",
          align: "left",
          sortable: false,
        },
        {
          text: "Contact Number",
          align: "left",
          sortable: false,
        },
        {
          text: "Birth Date",
          align: "center",
          sortable: false,
        },
        {
          text: "Registration Date",
          align: "center",
          sortable: false,
        },
      ],
      items: [
        {
          date: "May 8, 2019",
          time: "17:20:03",
          location: "PAS",
          branch: "TRIP1",
          merchant_id: "TRIPKO",
          device_id: "WP18371Q000000058",
          or_no: "TRIPKO-0000001",
          amount: 1200,
          mdr: 24,
          remarks: null,
        },
        {
          date: "May 8, 2019",
          time: "18:23:03",
          location: "PAS",
          branch: "TRIP1",
          merchant_id: "TRIPKO",
          device_id: "WP18371Q000000058",
          or_no: "TRIPKO-0000002",
          amount: 1200,
          mdr: 24,
          remarks: "test",
        },
      ],
    };
  },
  created() {},
  computed: {
    computedData() {
      return {
        id: this.data.id,
        items: this.items,
        amount_settled: this.totalSettle,
      };
    },
  },
  methods: {},
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 0px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
